var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { SupportedNetworks } from '../../config/networkAddresses';
import { getMultiNetworkPrice } from './helpers/get-multi-network-price';
import { getSingleNetworkPrice } from './helpers/get-single-network-price';
import { CURRENT_VERSION, getUrls } from '../../config/environment';
// This helper is so other parts of the Genius system can access price quotes through a wrapper url/single function
export default function getQuotingEnginePrice(_a) {
    return __awaiter(this, arguments, Promise, function (_b) {
        var geniusQuotingEngineUrl, numInputNetworks, numOutputNetworks, numUniqueNetworks, numTokens, response, isMultiInMultiOutOnSameNetwork, tokenInOrders, tokenOutOrders, executors, error_1;
        var PKP = _b.PKP, cloudWallet = _b.cloudWallet, solanaAddress = _b.solanaAddress, tokensIn = _b.tokensIn, tokensOut = _b.tokensOut, fromSlippage = _b.fromSlippage, toSlippage = _b.toSlippage, fromGasMultiplier = _b.fromGasMultiplier, toGasMultiplier = _b.toGasMultiplier, dlnTokenOrders = _b.dlnTokenOrders, permitBatchDetails = _b.permitBatchDetails, permitSignatures = _b.permitSignatures, publicKeys = _b.publicKeys, _c = _b.useDLN, useDLN = _c === void 0 ? false : _c, _d = _b.baseUrl, baseUrl = _d === void 0 ? '/api/wrapper?target=' : _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    console.log('starting quote fetch', {
                        cloudWallet: cloudWallet,
                        tokensIn: tokensIn,
                        tokensOut: tokensOut,
                        fromSlippage: fromSlippage,
                        toSlippage: toSlippage,
                        permitBatchDetails: permitBatchDetails,
                        permitSignatures: permitSignatures,
                        dlnTokenOrders: dlnTokenOrders,
                        useDLN: useDLN,
                        PKP: PKP,
                    });
                    geniusQuotingEngineUrl = baseUrl + getUrls().QUOTER_URL;
                    console.log('geniusQuotingEngineUrl', geniusQuotingEngineUrl);
                    _e.label = 1;
                case 1:
                    _e.trys.push([1, 6, , 7]);
                    console.log('QUOTE 1', geniusQuotingEngineUrl);
                    numInputNetworks = new Set(tokensIn.map(function (token) { return token.network; })).size;
                    numOutputNetworks = new Set(tokensOut.map(function (token) { return token.network; }));
                    numUniqueNetworks = new Set(__spreadArray(__spreadArray([], tokensIn.map(function (token) { return token.network; }), true), tokensOut.map(function (token) { return token.network; }), true)).size;
                    numTokens = tokensIn.length;
                    response = void 0;
                    if (!numInputNetworks || !numTokens) {
                        throw new Error('Invalid input');
                    }
                    isMultiInMultiOutOnSameNetwork = numUniqueNetworks === 1 && (tokensIn === null || tokensIn === void 0 ? void 0 : tokensIn.length) > 1 && (tokensOut === null || tokensOut === void 0 ? void 0 : tokensOut.length) > 1;
                    console.log('starting quote fetch numUniqueNetworks', numUniqueNetworks, isMultiInMultiOutOnSameNetwork, tokensIn, tokensOut);
                    if (!(numUniqueNetworks == 1 && !isMultiInMultiOutOnSameNetwork)) return [3 /*break*/, 3];
                    console.log('QUOTE SingleNetwork', tokensIn[0].network, tokensIn.map(function (token) { return token.address; }), tokensOut.map(function (token) { return token.address; }), tokensIn.map(function (token) { return token.amount; }), cloudWallet, tokensOut.map(function (token) { return token.percentage; }), geniusQuotingEngineUrl);
                    return [4 /*yield*/, getSingleNetworkPrice({
                            //@ts-ignore
                            PKP: PKP,
                            network: tokensIn[0].network,
                            tokensIn: tokensIn.map(function (token) { return token.address; }),
                            tokensOut: tokensOut.map(function (token) { return token.address; }),
                            amountsIn: tokensIn.map(function (token) { return token.amount; }),
                            fromAddress: cloudWallet,
                            receiver: cloudWallet,
                            slippages: tokensIn.map(function () { return fromSlippage; }),
                            ratio: tokensOut.map(function (token) { return token.percentage / 100; }),
                            baseUrl: geniusQuotingEngineUrl,
                            permitBatchDetail: permitBatchDetails[0],
                            permitSignature: permitSignatures[0],
                            publicKeys: publicKeys,
                        })];
                case 2:
                    //@ts-ignore
                    response = _e.sent();
                    return [3 /*break*/, 5];
                case 3:
                    console.log('solanaAddresskwieieiiew', solanaAddress);
                    tokenInOrders = tokensIn.map(function (token) { return ({
                        tokenIn: token.address,
                        network: token.network,
                        amountIn: token.amount,
                        fromAddress: cloudWallet,
                        solanaFromAddress: solanaAddress,
                    }); });
                    tokenOutOrders = tokensOut.map(function (token) {
                        var _a;
                        var network = token.network;
                        var executorContract = (_a = SupportedNetworks(CURRENT_VERSION)[network]) === null || _a === void 0 ? void 0 : _a.executor;
                        return {
                            tokenOut: token.address,
                            network: network,
                            fromAddress: executorContract,
                        };
                    });
                    console.log('QUOTE MultiNetwork', tokenInOrders, tokenOutOrders, fromSlippage, toSlippage);
                    executors = tokenInOrders.map(function (order) {
                        var _a;
                        var executor = (_a = SupportedNetworks(CURRENT_VERSION)[order.network]) === null || _a === void 0 ? void 0 : _a.executor;
                        if (!executor) {
                            throw new Error("Executor not found for network ".concat(order.network));
                        }
                        return executor;
                    });
                    console.log('baseurl', geniusQuotingEngineUrl);
                    return [4 /*yield*/, getMultiNetworkPrice({
                            PKP: PKP,
                            //@ts-ignore
                            tokenInOrders: tokenInOrders,
                            tokenOutOrders: tokenOutOrders,
                            fromSlippage: fromSlippage,
                            toSlippage: toSlippage,
                            fromGasMultiplier: fromGasMultiplier,
                            toGasMultiplier: toGasMultiplier,
                            permitBatchDetails: permitBatchDetails,
                            permitSignatures: permitSignatures,
                            baseUrl: geniusQuotingEngineUrl,
                            executors: executors,
                            ratio: tokensOut.map(function (token) { return token.percentage / 100; }),
                            publicKeys: publicKeys,
                            dlnTokenOrders: dlnTokenOrders,
                            useDLN: useDLN,
                        })];
                case 4:
                    //@ts-ignore
                    response = _e.sent();
                    _e.label = 5;
                case 5:
                    if (!response) {
                        throw new Error('Invalid response');
                    }
                    if (response === null || response === void 0 ? void 0 : response.error) {
                        // console.error('Error fetching price quote', response.error);
                        //@ts-ignore
                        return [2 /*return*/, response];
                    }
                    return [2 /*return*/, { quote: response }];
                case 6:
                    error_1 = _e.sent();
                    // console.error('Error fetching price quote', error);
                    return [2 /*return*/, { error: error_1.message }];
                case 7: return [2 /*return*/];
            }
        });
    });
}
